import IngredientProteinInfo, {
  IIngredientProteinInfo,
} from 'components/commandpanel/IngredientInfo/IngredientProteinInfo';
import React from 'react';

interface Props {
  compProps?: IIngredientProteinInfo;
}
const ProteinInfo = (props: Props) => {
  const { compProps } = props;
  return (
    <div id="searchandfilter-info-protectinfo-wrapper">
      <IngredientProteinInfo {...compProps} containerClassName="overflow-visible" />
    </div>
  );
};

export default ProteinInfo;
